
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Crown, Shield, User, UserRound, Users, UserCog } from "lucide-react";
import { UserRole } from "@/pages/users/types";

interface RoleFilterProps {
  onFilterChange: (role: UserRole | "all") => void;
  isClientView?: boolean;
}

export const RoleFilter = ({ onFilterChange, isClientView = false }: RoleFilterProps) => {
  return (
    <Select defaultValue={isClientView ? "guard" : "all"} onValueChange={onFilterChange}>
      <SelectTrigger className="w-40">
        <SelectValue placeholder="Filter by role" />
      </SelectTrigger>
      <SelectContent>
        {!isClientView && (
          <SelectItem value="all">
            <div className="flex items-center">
              All Roles
            </div>
          </SelectItem>
        )}
        {!isClientView && (
          <>
            <SelectItem value="admin">
              <div className="flex items-center">
                <Shield className="mr-2 h-4 w-4" />
                Admin
              </div>
            </SelectItem>
            <SelectItem value="manager">
              <div className="flex items-center">
                <Users className="mr-2 h-4 w-4" />
                Manager
              </div>
            </SelectItem>
            <SelectItem value="contributor">
              <div className="flex items-center">
                <UserCog className="mr-2 h-4 w-4" />
                Contributor
              </div>
            </SelectItem>
          </>
        )}
        <SelectItem value="guard">
          <div className="flex items-center">
            <User className="mr-2 h-4 w-4" />
            User
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
